import store from '@/store';

export default class SearchDropdownItemCode {
	constructor(
		private readonly name: string,
		private readonly id: number
	) { }

	public onClick(): void {
		store.mutations.addLinkedOrganisation({
			id: this.id,
			name: this.name
		});
	}
}
